export const icybluesandgrays = {
  name: 'Icy Blues and Grays',
  color: [0.7372549019607844, 0.7294117647058823, 0.7450980392156863, 1],
  bg: [0.9450980392156862, 0.9450980392156862, 0.9490196078431372, 1],
  grid1: [0.6313725490196078, 0.8392156862745098, 0.8862745098039215, 1],
  grid2: [0.09803921568627451, 0.5843137254901961, 0.6784313725490196, 1],
}
